import styled from 'styled-components'
import { Theme, Button } from '@pga/pga-component-library'

export const StyedWrapper = styled.div`
  font-family: ${Theme.fonts.Montserrat};
`

export const StyledButton = styled(Button)`
  padding: 13px 56px;
  width: 100%;
  border-radius: 3px;
  border-width: 1px;
  font-weight: 600;
  font-size: 14px;
  font-family: sans-serif;
`

export const StyledContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: #F7F7F7;
  padding: 40px 20px;
`
